import React, { useEffect, useState } from 'react';
import PublishIcon from '../../../../Assets/Icons/PublishIcon';
import LinesIcon from '../../../../Assets/Icons/LinesIcon';
import EditIcon from '../../../../Assets/Icons/EditIcon';
import DeleteIcon from '../../../../Assets/Icons/DeleteIcon';
import TicIcon from '../../../../Assets/Icons/TicIcon';
import { useDispatch, useSelector } from 'react-redux';
import { getInvitedUsers, inviteUser } from '../../../../module/action/auth';
import Spinner from '../../../../Constants/Spinner';

function AccountSetting() {
  const [users, setUsers] = useState([]);
  const [email, setEmail] = useState();
  const inviteuserloader = useSelector(e => e.Auth.inviteuserloader);
  const invitedUserLoader = useSelector(e => e.Auth.invitedUserLoader);
  const invitedUsersData = useSelector(e => e.Auth.invitedUsersData);

  const dispatch = useDispatch();
  const sentInvitation = () => {
    dispatch(
      inviteUser({ email }, () => {
        setEmail('');
        dispatch(getInvitedUsers());
      })
    );
  };
  useEffect(() => {
    dispatch(getInvitedUsers());
  }, []);
  return (
    <div className="AccountSetting t my-12 px-8 innerDashboard">
      <div className="header  justify-between flex">
        <div className="flex align-middle items-center">
          <h2 className="text-[32px] font-extrabold ">Account Settings</h2>
        </div>
      </div>

      <div className="accountForm mt-[56px]">
        <div className="addUsers mb-[32px]">
          <div className="flex justify-between items-center">
            {/* <p className='mb-6 font-bold'>
                            Change Password
                        </p> */}
          </div>
          <div className="userkDetail flex flex-wrap items-center justify-between px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
            <div className="w-full ">
              <p className="text-sm text-black font-semibold">Add Users</p>
              <label className="flex items-center">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className=" max-w-[508px] rounded-xl mt-[16px] text-sm border-[1px] border-[#dde4de] w-full h-[56px] px-6 outline-none text-[#7b867c]"
                  onChange={ev => {
                    setEmail(ev.target.value);
                  }}
                />
                <button
                  disabled={inviteuserloader}
                  className="rounded-xl md:ml-4  text-white bg-[#2a9134] py-3.5 px-6 mt-[16px] flex items-center justify-center md:w-auto w-[100%] disabled:opacity-5 disabled:cursor-not-allowed"
                  onClick={() => {
                    let arr = [...users];
                    arr.push(email);
                    setUsers(arr);
                    sentInvitation();
                  }}>
                  <PublishIcon className="mr-2" />
                  Send Invitation
                </button>
              </label>
              <div className="table  bg-[#eef2f0] rounded-s-lg  w-full ">
                {invitedUserLoader ? (
                  <Spinner />
                ) : (
                  invitedUsersData.map((a, i) => (
                    <div className="table-row" key={i}>
                      <div className="table-cell py-4 pl-4 align-middle w-[50px] ">
                        <LinesIcon />
                      </div>
                      <div className="table-cell py-4   align-middle  ">
                        <p className=" text-left font-bold" style={{ textAlign: 'left' }}>
                          {a.email}
                        </p>
                      </div>
                      <div className="table-cell py-4 pr-2  align-middle  ">
                        <div className="flex items-center justify-end">
                          <p className="mr-6">Invited</p>
                          {/* <button className="mr-2 flex items-center justify-center w-[32px] h-[32px] rounded-full bg-black">
                            <EditIcon width={26} height={24} pathProp={{ fill: '#000' }} />
                          </button>
                          <button className="flex items-center justify-center w-[32px] h-[32px] rounded-full bg-[#ca3030]">
                            <DeleteIcon pathProp={{ fill: '#fff' }} />
                          </button> */}
                        </div>
                      </div>
                    </div>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>

        <div className="choosePassword mb-[32px]">
          <div className="flex justify-between items-center">
            {/* <p className='mb-6 font-bold'>
                            Change Password
                        </p> */}
          </div>
          <div className="passwordkDetail flex flex-wrap items-center justify-between px-8 bg-[#eef2f0] rounded-s-lg py-6 w-full">
            <div className="w-full ">
              <p className="text-sm text-black font-semibold">Choose Password</p>
              <label className="flex items-center">
                <input
                  type="password"
                  placeholder="Enter Your New Password"
                  className=" max-w-[508px] rounded-xl mt-[16px] text-sm border-[1px] border-[#dde4de] w-full h-[56px] px-6 outline-none text-[#7b867c]"
                />
                <button className="rounded-xl md:ml-4  text-white bg-[#2a9134] py-3.5 px-6 mt-[16px] flex items-center justify-center md:w-auto w-[100%]">
                  <TicIcon className="mr-2" stroke="#fff" />
                  Save
                </button>
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AccountSetting;
